import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent } from '@ionic/react'
import { UseHeader } from '@cps'
import './index.scss'

interface IProps {
  info: IClauseInfo;
  reject?: () => void;
}

const ClauseDetail: FC<IProps> = (props: IProps) => {
  const { reject, info } = props
  return (
    <IonModal
      cssClass='mkt-clause-detail'
      isOpen
    >
      <UseHeader onBack={reject} title={info.clauseName}></UseHeader>
      <IonContent>
        <div className='content' dangerouslySetInnerHTML={{ __html: info.clauseContent }}></div>
      </IonContent>
    </IonModal>
  )
}

export default observer(ClauseDetail)
